import { accountSetMe } from '@slices/account';

import { accountGetMe } from '@services/account/account-get-me';
import { withAdminAuthData } from '@services/base/wrappers/with-admin-auth-data';

import { AccountFetchGetMe } from './types';

export const accountFetchGetMe: AccountFetchGetMe = () => {
  return async (dispatch) => {
    const data = await withAdminAuthData(accountGetMe, undefined).promise;

    dispatch(accountSetMe(data));

    return data;
  };
};
